import React from 'react';
import { useCaptions } from '../../context/CaptionsContext';
import { useLanguage } from '../../context/LanguageContext';
import './Captions.css';

const LABELS = {
  en: { off: 'Read Along',  on: 'Reading on',     aria: 'Toggle Read Along captions' },
  mr: { off: 'वाचत जा',     on: 'वाचत आहोत',     aria: 'सबटायटल्स सुरू / बंद करा' },
  hi: { off: 'साथ पढ़ें',   on: 'पढ़ रहे हैं',    aria: 'साथ पढ़ें — चालू / बंद' },
};

const CaptionsButton = ({ inline = false }) => {
  const { enabled, toggleEnabled, narrationKey } = useCaptions();
  const { language } = useLanguage();

  // Only show the toggle while a narration is actually playing — the
  // pill has nothing useful to do otherwise, and removing it keeps the
  // chrome quiet between stops. The inline variant (used inside the
  // guided-tour panel) stays mounted at all times so users always see
  // the toggle while a tour is running.
  if (!inline && !narrationKey) return null;

  const l = LABELS[language] || LABELS.en;
  const text = enabled ? l.on : l.off;

  return (
    <button
      type="button"
      onClick={toggleEnabled}
      aria-pressed={enabled}
      aria-label={l.aria}
      title={text}
      className={`captions-fab${inline ? ' captions-fab--inline' : ''}${enabled ? ' captions-fab--active' : ''}`}
    >
      <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
        {/* Speech-bubble + text-line glyph — friendlier than CC bars */}
        <path d="M4 5h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-7l-4 3v-3H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
          fill="none" stroke="currentColor" strokeWidth="1.6"
          strokeLinejoin="round" />
        <path d="M6 10h12M6 13h8" stroke="currentColor"
          strokeWidth="1.6" strokeLinecap="round" />
      </svg>
      <span className="captions-fab__text">{text}</span>
    </button>
  );
};

export default CaptionsButton;

